import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAuth } from "auth";
import { networkTypeSelector } from "store/userSliceHelpers";
import { merchantInfoQuery } from "./merchantInfoQuery";

// Merchant profile/info, keyed by merchantId. Its `merchantAddress` is what the
// balance and transactions queries depend on (they stay disabled until it resolves).
export function useMerchantInfo(merchantId: string | undefined) {
  const { user } = useAuth();
  const networkType = useSelector(networkTypeSelector);
  return useQuery({
    ...merchantInfoQuery(merchantId ?? "", networkType),
    enabled: !!user && !!merchantId,
  });
}
